import { type FC } from "react";

import { clsx } from "clsx";

// One report page, its image sized up front so lazy loading doesn't shift the
// scroll. `targeted`: the page a tag opened (teal). `mark` (violet): reading
// it now, found by its latest search, or read in this chat.
export const PageFrame: FC<{
  id: string;
  number: number;
  url?: string | null;
  width?: number | null;
  height?: number | null;
  targeted: boolean;
  mark?: "reading" | "found" | "read";
}> = ({ id, number, url, width, height, targeted, mark }) => (
  <div
    id={id}
    data-page={number}
    className="flex scroll-mt-16 flex-col gap-1.5"
  >
    <span
      className={clsx(
        "text-[11px] font-semibold",
        targeted ? "text-indigo-600" : "text-slate-500",
      )}
    >
      Page {number}
    </span>
    <img
      src={url ?? undefined}
      alt={`Page ${String(number)}`}
      loading="lazy"
      width={width && width > 0 ? width : 2550}
      height={height && height > 0 ? height : 3300}
      className={clsx(
        "h-auto w-full rounded border border-slate-200 bg-white",
        targeted && "ring-2 ring-indigo-500",
        mark === "reading" &&
          "border-violet-200 shadow-[inset_3px_0_0_#8b5cf6,0_0_0_4px_#f5f3ff]",
        mark === "found" &&
          "outline-2 -outline-offset-2 outline-violet-300 outline-dashed",
        mark === "read" && "shadow-[inset_3px_0_0_#a78bfa]",
      )}
    />
  </div>
);
